import { render, staticRenderFns } from "./AdminAuditLog.vue?vue&type=template&id=03390751"
import script from "./AdminAuditLog.vue?vue&type=script&lang=js"
export * from "./AdminAuditLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports